import { useIsLever, useTheme } from "../../reducers/layoutReducer/selectors";

import brivityHeroImage from "./images/brivity-x-connect-hero.jpg";
import leverHeroImage from "./images/lever-x-connect-hero.jpg";
import placeHeroImage from "./images/place-x-connect-hero.jpg";

const BRANDS = {
  brivity: {
    name: "Brivity",
    hero: brivityHeroImage,
    logo: "/images/brivity-logo.svg",
    logoClassName: "tw-h-[24px] tw-w-[118px]",
  },
  lever: {
    name: "Lever",
    hero: leverHeroImage,
    logo: "/images/lever-logo.png",
    logoClassName: "tw-h-[32px] tw-w-[108px]",
  },
  place: {
    name: "PLACE",
    hero: placeHeroImage,
    logo: "/images/place-logo.svg",
    logoClassName: "tw-h-[27px] tw-w-[143px]",
  },
};

const useBrand = () => {
  const isLever = useIsLever() as boolean | undefined;
  const isPlaceTheme = (useTheme() as { name?: string } | undefined)?.name === "place-theme";

  if (isLever) return BRANDS.lever;

  return isPlaceTheme ? BRANDS.place : BRANDS.brivity;
};

export default useBrand;
